export default __webpack_public_path__ + "static/media/logo-blue.415b1cb4.svg";